// extracted by mini-css-extract-plugin
module.exports = {"tags":"tags-module--tags--CY1-e","plain":"tags-module--plain--1ek55","centered":"tags-module--centered--3HNYo"};